import type { ElementType, HTMLAttributes } from 'react';
import { cx, type Tone } from './cx';

// Rediseño · Bloque A. La tarjeta es la superficie base del rediseño: blanca, redonda y con una
// sombra suave. Con `tone` se vuelve una tarjeta de color (fondo pastel, sin sombra).
// No trae título ni acciones propios: eso lo pone `SectionHeader` o el contenido de cada pantalla.
export interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Elemento HTML. Usa `section` o `article` cuando la tarjeta tenga su propio encabezado. */
  as?: 'div' | 'section' | 'article' | 'aside' | 'li';
  tone?: 'surface' | Tone;
  /** `xl` (26 px) para la tarjeta protagonista; `lg` (22 px) para las de una lista. */
  radius?: 'xl' | 'lg';
  /** `md` es fluido: 16 px en teléfono, 22 px en escritorio. */
  padding?: 'md' | 'sm' | 'none';
}

export function Card({ as = 'div', tone = 'surface', radius = 'xl', padding = 'md', className, children, ...rest }: CardProps) {
  const Element: ElementType = as;
  return (
    <Element
      {...rest}
      className={cx(
        'n3-card',
        tone !== 'surface' && `n3-card--${tone}`,
        radius === 'lg' && 'n3-card--radius-lg',
        padding !== 'md' && `n3-card--padding-${padding}`,
        className,
      )}
    >
      {children}
    </Element>
  );
}
